<div class="side-attachments">
    <div class="sidepanel-table" [ngClass]="{'setHeight' : sidePanelData.isArchive}">
        <!--<div class="block-title">
            <h2>Notes (1)</h2>
        </div> -->
      <div class="side-note-container" >
        <div class="notes-box" *ngFor="let eandONote of eandONotes;">
          <div class="img-block">
            <!-- <img _ngcontent-mxp-c149="" alt="user-icon"
                 src="https://ui-avatars.com/api/?name={{eandONote.createdByName | initials}}&amp;rounded=true&amp;background={{eandONote.colorCode}}&amp;font-size=0.4&amp;size=24&amp;bold=true">
            <div class="block-title">
              <h2>{{eandONote.createdByName | titlecase}}</h2>
            </div> -->
            <span title="{{eandONote.memo}}">{{eandONote.memo}}</span>
          </div>
          <div class="d-flex">
            <span class="time-note">{{eandONote.createdByName | titlecase}}</span>
            <span class="seprator mx-1"></span>
            <span class="time-note">{{eandONote.createdOn | date: 'MM/dd/yyyy hh:mm a'}}</span>
          </div>
          <!-- <div class="clear"></div> -->
          <!-- <div class="block-desc">
            
            <p>{{eandONote.memo}}</p>
          </div> -->
        </div>
        

      </div>
      <div class="no-data-found inside-attachment" *ngIf="(eandONotes == null || (eandONotes != null && eandONotes.length <= 0))">
        <img src="../../../../assets/images/no-data.svg">
        <h5>No notes here</h5>
        <div>Notes would be visible here</div>
      </div>
    </div>
    <div class="request-activity-container" *ngIf="!sidePanelData.isArchive">
        <form class="group-form" [formGroup]="eandODetailNote">
            <div class="data-form" >
                <div class="text-count">
                    <textarea name="notes" maxlength="500" class="form-control" id="memo" cols="30" rows="10"
                        placeholder="Add a note..." formControlName="memo"></textarea>
                    <div class="notes-count">
                      <p class="m-0">({{eandODetailNote.value.memo.length}}/500)</p>
                        <a class="commn-btn" href="javascript:void()" [class.disabled]="!eandODetailNote.valid || !isMemoValid" (click)="submitNote()">Add</a>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
